import { render, staticRenderFns } from "./DebtCollectionOverview.vue?vue&type=template&id=6949bdbc&"
import script from "./DebtCollectionOverview.vue?vue&type=script&lang=js&"
export * from "./DebtCollectionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports